import { useMediaQuery } from "@mui/material";
import GradientText from "../Common/GradientText";
import { useTranslation } from "react-i18next";

/**
 * A stylized title component for displaying the word "Frigyes" with a gradient text effect.
 *
 * This component uses Material UI's `Typography` and supports responsive design:
 * it adjusts its margin and font size based on the screen width (`min-width: 640px`).
 *
 * Gradient colors are derived from the current MUI theme, and the text is visually styled
 * using CSS background clipping to show the gradient inside the text.
 *
 * @returns {JSX.Element} The rendered title element
 */
export const AlexxisTitle = () => {
    const { t } = useTranslation("translation", { keyPrefix: "chat" });
    const min640 = useMediaQuery("(min-width:640px)");

    return (
        <GradientText variant="h1" sx={{ marginTop: min640 ? "30px" : "50px", fontSize: min640 ? "6em" : "4rem", fontWeight: 600 }}>
            {t("alexxisTitle")}
        </GradientText>
    );
};
